export enum ApplicationContext {
    AGENT = 'AGENT',
    AGENT_MOBILE = 'AGENT_MOBILE',
    DIAGNOSTIC_STATION = 'DIAGNOSTIC_STATION',
}

export enum ApplicationContextUrlParamValue {
    AGENT = 'agent', // YWdlbnQ=
    AGENT_MOBILE = 'agent-mobile', // YWdlbnQtbW9iaWxl
    DIAGNOSTIC_STATION = 'diagnostic-station', // ZGlhZ25vc3RpYy1zdGF0aW9u
}
